import App from '../ui/App.svelte';

const app = new App({
	target: document.body,
});

export default app;
